import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children, allowedTypes = [] }) => {
  const location = useLocation();
  const { user, token } = useSelector((state) => state.auth);

  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedTypes.length > 0 && !allowedTypes.includes(user.type)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
